module.exports = __webpack_public_path__ + "img/ids_fhir.eb14af8d.png";